import ExchangePage from 'screens/ExchangeRate/ExchangeRate';

export default ExchangePage;
